/**
 * Created by neo on 19.12.20.
 */
import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';
import { LocalizedValue, createLocalizedValue } from '../../LocalizedValue';
import { Media, createMedia } from '../../Media/Media';

export type DietEquipment = {
  id: string;
  spoonacularId: number;
  name: LocalizedValue[];
  image?: Media;
};

export function createDietEquipment(json?: Partial<DietEquipment>): DietEquipment {
  return makeAutoObservable({
    id: json?.id ?? UUID(),
    spoonacularId: json?.spoonacularId ?? 0,
    name: (json?.name ?? []).map((n: any) => createLocalizedValue(n)),
    image: json?.image ? createMedia(json.image) : undefined,
  });
}
